module.exports = __webpack_public_path__ + "img/chivas-crystal-bottle-age.3b292d66.jpg";